import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
// Material imports
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button"; // Limitless imports

import { getLastAmbassadorDialogue } from "../../../../common/utils";
import { withi18n } from "../../hocs/i18n";
import UserAvatar from "../../user-avatar/UserAvatar";
import RatingSystem from "../csat-footer/RatingSystem";

var CSATScreen = function CSATScreen(_ref) {
  var logger = _ref.logger,
      t = _ref.t,
      classes = _ref.classes,
      onSubmitCSATScore = _ref.onSubmitCSATScore,
      message = _ref.message,
      containerClass = _ref.containerClass;

  var _React$useState = React.useState(-1),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      score = _React$useState2[0],
      setScore = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      disableButton = _React$useState4[0],
      setDisableButton = _React$useState4[1];

  var _React$useState5 = React.useState(message.customerScore || message.custScoreScheme.defaultScore),
      _React$useState6 = _slicedToArray(_React$useState5, 1),
      showNext = _React$useState6[0];

  var _getLastAmbassadorDia = getLastAmbassadorDialogue(message),
      hasSingleExpert = _getLastAmbassadorDia.hasSingleExpert,
      _getLastAmbassadorDia2 = _getLastAmbassadorDia.lastDialogue.author,
      author = _getLastAmbassadorDia2 === void 0 ? "" : _getLastAmbassadorDia2,
      thumbnail = _getLastAmbassadorDia.thumbnail;

  logger.debug("CSATScreen: ", message);

  var handleRate = function handleRate(score) {
    if (!showNext) {
      onSubmitCSATScore(score);
    } else {
      setScore(score);
    }
  };

  var handleNext = function handleNext() {
    setDisableButton(true);
    onSubmitCSATScore(score);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(containerClass, " ").concat(!hasSingleExpert || !thumbnail ? classes.center : "")
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    classes: {
      subtitle2: classes.heading
    },
    component: "div"
  }, hasSingleExpert ? t("How would you rate {0}?", author) : t("How was your experience?")), /*#__PURE__*/React.createElement("div", {
    className: classes.ratingWrapper
  }, hasSingleExpert && thumbnail && /*#__PURE__*/React.createElement("div", {
    className: classes.avatarContainer
  }, /*#__PURE__*/React.createElement(UserAvatar, {
    thumbnail: thumbnail,
    author: author,
    avatarClassName: classes.avatar
  })), /*#__PURE__*/React.createElement(RatingSystem, {
    onClick: handleRate,
    message: message,
    disabled: false
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.nextButtonContainer
  }, showNext ? /*#__PURE__*/React.createElement(Button, {
    classes: {
      root: classes.nextButton
    },
    variant: "contained",
    color: "primary",
    onClick: handleNext,
    component: "div",
    id: "nextButton",
    disabled: disableButton
  }, t("Next")) : /*#__PURE__*/React.createElement(React.Fragment, null)));
};

var styles = function styles() {
  return {
    heading: {
      marginTop: 16
    },
    ratingWrapper: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    },
    avatarContainer: {
      margin: "16px 0"
    },
    nextButtonContainer: {
      display: "flex",
      justifyContent: "center",
      marginBottom: 16,
      marginTop: 16
    },
    nextButton: {
      width: 100
    },
    avatar: {
      width: 50,
      height: 50
    },
    center: {
      justifyContent: "center"
    }
  };
};

export default withStyles(styles)(withi18n(CSATScreen, "CSATScreen"));